import Text from "common/Typography/Text";
import styled from "styled-components";
import { typography } from "@shared/common/Themes/typography";

interface OrderCardExtraInfoProps {
  orderExtraData?: [string, string][];
}

const OrderCardExtraData = ({ orderExtraData }: OrderCardExtraInfoProps) => {
  const extraDataRow = (key: string, value: string) => (
    <RowWrapper key={key}>
      <Text
        $size={typography.fontSizes.S}
        type={"secondary"}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        {key}
      </Text>
      <Text
        $size={typography.fontSizes.S}
        $weight={typography.fontWeights.SEMI_BOLD}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        {value}
      </Text>
    </RowWrapper>
  );

  return <>{orderExtraData?.map(([key, value]) => extraDataRow(key, value))}</>;
};

export default OrderCardExtraData;

const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
`;
